/**
 * Memory API — agentic Q&A from the chat composer.
 *
 * The endpoint runs the AskMemory use case synchronously (no queue),
 * so a request can take up to a few seconds while the agent loops on
 * its tools. Callers should show a loading bubble.
 */
import { request } from "./client";
import type { AskRequest, AskResponse } from "../lib/types";

export async function askMemory(
  question: string,
  signal?: AbortSignal,
): Promise<AskResponse> {
  const body: AskRequest = { question };
  return request<AskResponse>("/api/v1/memory/ask", {
    method: "POST",
    body,
    signal,
  });
}
